import { render } from "./PromocodeFooter.vue?vue&type=template&id=9bf35d00&scoped=true&ts=true"
import script from "./PromocodeFooter.vue?vue&type=script&lang=ts"
export * from "./PromocodeFooter.vue?vue&type=script&lang=ts"

import "./PromocodeFooter.vue?vue&type=style&index=0&id=9bf35d00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bf35d00"]])

export default __exports__